import React from 'react';
import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

const icons = {
  success: CheckCircle,
  error: XCircle,
  info: Info,
  warning: AlertCircle
};

const styles = {
  success: 'bg-aquamarine/10 text-spring-green border-spring-green/20',
  error: 'bg-bittersweet/10 text-bittersweet border-bittersweet/20',
  info: 'bg-sky-blue/10 text-sky-blue border-sky-blue/20',
  warning: 'bg-bittersweet/10 text-violet border-celadon/20'
};

export default function Alert({ type = 'info', title, children, className = '' }) {
  const Icon = icons[type];

  return (
    <div className={twMerge(
      'rounded-xl border p-4 flex items-start gap-3',
      styles[type],
      className
    )}>
      <Icon className="h-5 w-5 flex-shrink-0" />
      <div>
        {title && <h4 className="font-semibold mb-1 font-heading">{title}</h4>}
        <div className="text-sm">{children}</div>
      </div>
    </div>
  );
}